import { Chip, type ChipProps } from '@mui/material';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';
import { useTranslation } from 'react-i18next';
import type { BookingStatus } from '../../shared/services/bookings.service';

const STATUS_COLOR: Record<BookingStatus, ChipProps['color']> = {
  PENDING: 'warning',
  CONFIRMED: 'success',
  COUNTER_PROPOSED: 'info',
  CANCELLATION_REQUESTED: 'warning',
  REJECTED: 'error',
  CANCELLED: 'default',
};

const STATUS_ICON: Record<BookingStatus, React.ReactElement> = {
  PENDING: <HourglassTopRoundedIcon sx={{ fontSize: '0.95rem !important' }} />,
  CONFIRMED: <CheckCircleRoundedIcon sx={{ fontSize: '0.95rem !important' }} />,
  COUNTER_PROPOSED: <SwapHorizRoundedIcon sx={{ fontSize: '0.95rem !important' }} />,
  CANCELLATION_REQUESTED: <HelpOutlineRoundedIcon sx={{ fontSize: '0.95rem !important' }} />,
  REJECTED: <BlockRoundedIcon sx={{ fontSize: '0.95rem !important' }} />,
  CANCELLED: <CancelRoundedIcon sx={{ fontSize: '0.95rem !important' }} />,
};

type Props = {
  status: BookingStatus;
  size?: 'small' | 'medium';
};

export function BookingStatusChip({ status, size = 'small' }: Props) {
  const { t } = useTranslation();
  return (
    <Chip
      icon={STATUS_ICON[status]}
      label={t(`bookings.status.${status}`)}
      color={STATUS_COLOR[status]}
      size={size}
      sx={{ fontWeight: 600 }}
    />
  );
}
